import { render, staticRenderFns } from "./description-section.vue?vue&type=template&id=6c18ff74&scoped=true"
import script from "./description-section.vue?vue&type=script&lang=js"
export * from "./description-section.vue?vue&type=script&lang=js"
import style0 from "./description-section.vue?vue&type=style&index=0&id=6c18ff74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c18ff74",
  null
  
)

export default component.exports